import { render, staticRenderFns } from "./SearchMenu.vue?vue&type=template&id=4f84b8c2&scoped=true"
import script from "./SearchMenu.vue?vue&type=script&lang=js"
export * from "./SearchMenu.vue?vue&type=script&lang=js"
import style0 from "./SearchMenu.vue?vue&type=style&index=0&id=4f84b8c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f84b8c2",
  null
  
)

export default component.exports